<script setup lang="ts">
import { permissions } from '~/data/permissions';

const modalsStore = useModalsStore();

function handlePreviewPermission(img: string) {
    modalsStore.showImagePreview(img);
};
</script>

<template>
    <SectionsBase class="background">
        <div class="container">
            <ChipsDivider>مجوزها</ChipsDivider>
            <h2>مجوزها و اعتبارنامه‌های رسمی نواتل</h2>
            <p class="text-center text-gray-500 h4 my-6 lg:mb-8">نواتل با برخورداری از تمامی مجوزهای رسمی حوزه ارتباطات و فناوری اطلاعات، تضمینی مطمئن برای کیفیت و امنیت خدمات شماست.</p>
            <div class="w-full grid grid-cols-2 lg:flex lg:items-center lg:justify-center gap-2 lg:gap-10">
                <NuxtImg
                    v-for="permission, index in permissions"
                    :key="permission.title"
                    :src="permission.logo"
                    :alt="permission.title"
                    width="200"
                    class="cursor-pointer transition-all duration-300 mx-auto lg:mx-0 max-w-27.5 lg:max-w-50 hover:scale-105"
                    :class="[
                        index === 0 && 'order-2 lg:order-1',
                        index === 1 && 'order-3 lg:order-2',
                        index === 2 
                            ? 'col-span-2 order-1 lg:order-3 mb-3 lg:mb-0'
                            : 'order-4',
                    ]"
                    @click="handlePreviewPermission(permission.img)"
                />
            </div>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";

.background {
    background: linear-gradient(
        135deg, 
        white 10%, 
        var(--color-primary-100), 
        var(--color-secondary-100) 80%, 
        white
    );
}
</style>